import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import { callGetClientTokenApi, GetClientTokenResData } from 'requests/RequestCard';
import { HttpStatus } from 'consts/HttpStatus';

export const usePayPalClientToken = () => {
	const history = useHistory();
	const [clientTokenResData, setClientTokenResData] = useState<GetClientTokenResData>(undefined);
	const [getClientTokenLoading, setGetClientTokenLoading] = useState(true);
	useEffect(() => {
		const execute = async () => {
			const result = await callGetClientTokenApi();
			if (result.status !== HttpStatus.OK || !result.data) {
				history.push(RoutePath.ERROR);
				return;
			}
			const resultData = result.data as GetClientTokenResData;
			setClientTokenResData(resultData);
			setGetClientTokenLoading(false);
		};
		execute();
	}, []);

	return {
		clientTokenResData,
		getClientTokenLoading,
	};
};
